<template>
    <ValidationObserver ref="observer" v-slot="{ passes }">
        <div class="columns has-text-left flex-warp mg-t-4">
            <div class="column is-12 text-center">
                <div class="box-profile">
                    <div v-if="form.profileImage != null && form.file">
                        <img :src="form.profileImage" alt="">
                    </div>
                    <div v-if="form.profileImage != null">
                        <img :src="url+form._id+'/'+form.profileImage" alt="">
                    </div>
                    <div v-else>
                        <i class="fas fa-user fa-3x text-grey"></i>
                    </div>
                </div>
                <b-upload v-model="form.file" expanded @input="uploadFile" class="mg-t-3" > 
                    <a class="button is-fullwidth" :style="styleObject">
                    <b-icon icon="upload"></b-icon>
                    <span>อัพโหลดรูป</span>
                    </a>
                </b-upload>
            </div>
            <div class="column is-6 ">
                <BInputWithValidation
                    rules="required"
                    label="ชื่อ"
                    v-model="form.name"
                />
            </div>
            <div class="column is-6">
                <BInputWithValidation
                    rules="required"
                    label="นามสกุล"
                    v-model="form.surname"
                />
            </div>
            <div class="column is-6 ">
                <BInputWithValidation rules="required|email" type="email" :disabled="editProfile" label="อีเมล" v-model="form.email"/>
            </div>
            <div class="column is-6 " />
            <div class="column is-6 ">
                <b-field label="หน่วยงาน">
                    <b-input v-model="form.department"></b-input>
                </b-field>
            </div>
            <div class="column is-6">
                 <b-field label="ตำแหน่ง">
                    <b-input v-model="form.position"></b-input>
                </b-field>
            </div>
        </div>
        <b-button @click="passes(saveData)" :style="styleObject" class="mg-t-4 button-secondary">บันทึก</b-button>
    </ValidationObserver>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import BInputWithValidation from "@/components/inputs/BInputWithValidation";
export default {
    components:{
        ValidationObserver,
        BInputWithValidation
    },
    data(){
        return{
            url:process.env.VUE_APP_IMAGE_USER,
            form:{
                name:'',
                surname:'',
                email:'',
                position:'',
                department:'',
                file:{},
                profileImage:'',
            }
        }
    },
    props:{
        editProfile:{
            type: Boolean,
            default: true
        },
        userData:{
            type: Object,
            default: ()=> { return {} }
        }
    },
    mounted(){
        this.form = this.userData
        if(typeof this.form.profileImage == 'undefined' || this.form.profileImage == null){
            this.form.profileImage = ''
        }
    },
    methods:{
        saveData(){
            this.$emit('saveData',this.form)
        },
        uploadFile(event){
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL( event );
            this.form.profileImage = imageUrl
        }
    }
}
</script>